import api from '../../utils/api';

export interface PrescriptionQueueRow {
  prescriptionId: string;
  userId: string;
  userName: string | null;
  userPhone: string | null;
  deliveryAddress: string | null;
  deliveryPincode: string | null;
  queueStatus: 'pending' | 'assigned' | 'cancelled';
  status: string;
  cancelledBy?: 'user' | 'vendor' | null;
  cancellationReason?: string | null;
  isAccepted: boolean;
  vendorsNotified: number;
  requestedVendorNames: string[];
  requestedVendorPincodes: string[];
  requestedVendors: Array<{
    vendorId: string;
    name: string;
    pincode: string | null;
    kind: string;
  }>;
  reminderSentCount: number;
  activeReminderCount: number;
  acceptedByVendorId: string | null;
  acceptedByVendorName: string | null;
  hasPrescriptionFiles: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PrescriptionQueueResponse {
  success: boolean;
  data: {
    queue: PrescriptionQueueRow[];
    pagination: {
      currentPage: number;
      totalPages: number;
      totalItems: number;
      itemsPerPage: number;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
}

export async function getPrescriptionQueue(params?: {
  page?: number;
  limit?: number;
  search?: string;
  status?: 'pending' | 'assigned' | 'cancelled' | 'all';
}): Promise<PrescriptionQueueResponse> {
  const { page = 1, limit = 20, search = '', status = 'pending' } = params || {};
  const response = await api.get<PrescriptionQueueResponse>('/master-admin/prescription-queue', {
    params: { page, limit, search, status },
  });
  return response.data;
}
